export default {"src":"/_next/static/media/ic-play.b5008d79.svg","height":40,"width":40};